import React, { FunctionComponent } from 'react';

import { InsuredItem } from 'scenes/common/types';
import { getPropertyUsedForBusiness } from 'scenes/home/selectors';
import { PropertyUsedForBusinessStep as CommonPropertyUsedForBusiness } from 'scenes/common/components/Steps';
import { HomeFullPageProps } from 'scenes/home/types';

const PropertyUsedForBusinessStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <CommonPropertyUsedForBusiness
    insuredItem={InsuredItem.Home}
    defaultStateValue={getPropertyUsedForBusiness(funnelState)}
    onNext={onNext}
    helpText="If you're running a business from home, please select yes. Select no, if you're currently working from home."
  />
);

export default PropertyUsedForBusinessStep;
